import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import Navbar from '../components/simons-marketing/Navbar';
import Footer from '../components/simons-marketing/Footer';
import FreeAnalysisForm from '../components/free-analysis/FreeAnalysisForm';
import FreeAnalysisBenefits from '../components/free-analysis/FreeAnalysisBenefits';

const FreeAnalysis = () => {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>{t('meta.analysis.title')}</title>
        <meta name="description" content={t('meta.analysis.description')} />
      </Helmet>
      <div className="min-h-screen bg-white">
        <Navbar />
        <main>
          <section className="relative pt-32 pb-20 overflow-hidden">
            <div className="absolute inset-0 bg-gradient-to-br from-gray-950 via-gray-900 to-emerald-950" />
            <div className="absolute inset-0 opacity-[0.03]" style={{
              backgroundImage: 'radial-gradient(circle at 1px 1px, white 1px, transparent 0)',
              backgroundSize: '40px 40px',
            }} />
            <div className="absolute top-20 right-10 w-72 h-72 bg-emerald-500/10 rounded-full blur-3xl" />
            <div className="absolute bottom-10 left-10 w-96 h-96 bg-teal-500/5 rounded-full blur-3xl" />

            <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
              <Link
                to="/"
                className="inline-flex items-center gap-2 text-emerald-300 hover:text-emerald-200 transition-colors mb-8 group"
              >
                <ArrowLeft className="w-4 h-4 group-hover:-translate-x-1 transition-transform" />
                <span className="text-sm font-medium">{t('free_analysis_page.back')}</span>
              </Link>

              <div className="max-w-2xl">
                <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-emerald-500/10 border border-emerald-500/20 mb-6">
                  <span className="text-sm font-medium text-emerald-300">{t('free_analysis_page.badge')}</span>
                </div>
                <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white leading-[1.1] mb-4">
                  {t('free_analysis_page.title')}{' '}
                  <span className="bg-gradient-to-r from-emerald-400 to-teal-300 bg-clip-text text-transparent">
                    {t('free_analysis_page.title_highlight')}
                  </span>
                </h1>
                <p className="text-lg text-gray-400 leading-relaxed max-w-xl">
                  {t('free_analysis_page.subtitle')}
                </p>
              </div>
            </div>
          </section>

          <section className="py-16 md:py-20">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
              <div className="grid lg:grid-cols-5 gap-12 lg:gap-16">
                <div className="lg:col-span-3">
                  <div className="bg-white rounded-2xl border border-gray-200 shadow-xl shadow-gray-200/50 p-8 md:p-10">
                    <h2 className="text-2xl font-bold text-gray-900 mb-2">
                      {t('free_analysis_page.form_title')}
                    </h2>
                    <p className="text-gray-500 mb-8">
                      {t('free_analysis_page.form_subtitle')}
                    </p>
                    <FreeAnalysisForm />
                  </div>
                </div>
                <div className="lg:col-span-2">
                  <FreeAnalysisBenefits />
                </div>
              </div>
            </div>
          </section>
        </main>
        <Footer />
      </div>
    </>
  );
};

export default FreeAnalysis;
